module.exports = __webpack_public_path__ + "img/btn_lung_on.1fd3e080.svg";